import React from "react";
import { Link, useNavigate } from "react-router-dom";

import "./Footer.css";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedinIn,
  FaGithub,
} from "react-icons/fa";

function Footer() {
  const navigate = useNavigate();
  const ShowDesignHandel = () => {
    navigate("/to_do");
  };
  return (
    <div className="footer">
      <div className="container -fluid">
        <div className="row d-flex justify-content-center">
          <div className="col-md-4 col-sm-12 col-12">
            <div className="adress-part">
              <h1>
                <Link>
                  <span>H</span>as<span>A</span>n
                </Link>
              </h1>

              <p>20/40 joship road</p>
              <span>Dhaka,Kalibari</span>
              <h2>(+880)1782572426</h2>
              <div className="icons d-flex">
                <a href="https://www.facebook.com/profile.php?id=100085191756581">
                  <FaFacebook />
                </a>
                <a>
                  <FaInstagram />
                </a>
                <a href="https://www.linkedin.com/in/hasanul-haque-shiblu-323737263/">
                  <FaLinkedinIn />
                </a>
                <a href="https://github.com/hhshiblu">
                  <FaGithub />
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-sm-12 col-12 footer-map">
            <div>
              <h2>SiteMap</h2>
              <ul>
                <li>
                  <Link to="/"> Home</Link>
                </li>
                <li>
                  {" "}
                  <Link to="/about">About</Link>{" "}
                </li>
                <li>
                  <Link to="/service">Service</Link>{" "}
                </li>
                <li>
                  <Link to="portfolio">Portfolio</Link>{" "}
                </li>
                <li>
                  <Link to="contact_me">Contact me</Link>{" "}
                </li>
                <li  onClick={ShowDesignHandel}>Show design</li>
              </ul>
            </div>
          </div>

          <div className="col-md-4 col-sm-12 col-12">
            <div className="suscribe-part">
              <h3>Want my best marketing tips?</h3>
              <p>
                Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                Explicabo!
              </p>

              <div className="email d-flex">
                <input type="email" placeholder="Your E-mail" name="email" />
                <button type="submit" className="btn btn-success">
                  send me
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
